export const getStarRatingFromMouseEvent = (
    event,
    componentRef,
    isAnimated = false
) => {
    const { left } = componentRef.current.getBoundingClientRect();
    const { clientX } = event;
    const position = clientX - left;
    const width = componentRef.current.clientWidth;
    const percentage = position / width;
    const rating = isAnimated
        ? Math.ceil((percentage * 10) / 2)
        : Math.ceil(percentage * 10) / 2;

    return rating;
};
